import config from "../config.json";

export function withConfiguration(cb) {
  return cb(config[process.env.REACT_APP_ENV]);
}

export function getConfig() {
  return config[process.env.REACT_APP_ENV];
}
